import Api, { ErrorMode, FetchMethodType } from './Api';

export interface GetReferralLinkResponse {
  referralLink: string;
}

export interface ReferralApi {
  getReferralLink(applicationId: string): Promise<GetReferralLinkResponse>;
}

export default class ReferralRestApi extends Api implements ReferralApi {
  public async getReferralLink(applicationId: string): Promise<GetReferralLinkResponse> {
    return this.fetch<GetReferralLinkResponse>(`/referral/${applicationId}/link`, {
      method: FetchMethodType.GET,
      errorMode: ErrorMode.HideError,
    });
  }
}
